/**
 * ============================================================================
 * NewbannerFormTemplete — View (UI only)
 * ============================================================================
 */
"use client";

import {
  OTPContext,
  OTPContextProvider,
  OTPContextWrapper,
} from "@/components/sections/CommonModals/context";
import ProgramDetailsOpenRfi from "../ProgramDetailsOpenRfi";
import styles from "../NewBannerForm.module.scss";
import type { NewbannerFormTempleteViewModel } from "../model/newbannerFormTemplete.types";
import UnivoLink from "@/components/common/UnivoLink";
import ApplicationFormRedirectLoader from "@/components/molecules/ApplicationFormRedirectLoader/ApplicationFormRedirectLoader";

export default function NewbannerFormTempleteView(
  vm: NewbannerFormTempleteViewModel,
) {
  const {
    ref,
    isMobile,
    isFaq,
    associatedPrograms,
    ProgramId,
    FaqHeading,
    RFIHeading,
    BannerImageTemplete,
    isLandingPage,
    isLambdaAPI,
    isAffiliatePage,
    seatFilledDisplay,
    isStatsDisplay,
    isJobRole,
    seatFilledCount,
    isJobPage,
    isOneYearMba,
    className,
    ctaButtonLabel,
    isCityPage,
    redirectToThankYou,
    loadingCount,
    isApplicationRedirectLoaderDisabled,
    slug,
    setApplicationRedirectLoaderDisabled,
    gtEventHandler,
    redirectHandler,
  } = vm;

  return (
    <div
      style={
        isJobRole
          ? {
              padding:
                "clamp(20px, 2vw, 40px) clamp(12px, 2vw, 23px) clamp(24px, 2vw, 40px)",
            }
          : undefined
      }
      onClick={gtEventHandler}
      ref={ref}
      className={`${styles.root} ${isJobRole && styles.jobRoleRoot} ${isFaq && styles.faqroot} ${className || ""}`}
    >
      <OTPContextProvider isLambdaAPI={isLambdaAPI}>
        <OTPContext.Consumer>
          {({ leadResponse, redirectApplicationJourneyUrl, isOTPSent }) => {
            return !isApplicationRedirectLoaderDisabled ? (
              redirectToThankYou ? (
                <ApplicationFormRedirectLoader redirectTime={loadingCount} text="" />
              ) : (
              <div>
                <div className={styles.thankYou}>
                  Thank You For Your Interest!{"\u00a0"}
                </div>
                <div className={styles.paragraph}>
                  We have successfully received your information. One of our
                  counsellors will contact you shortly.
                </div>
                {!isJobPage && (
                  <UnivoLink
                    href={
                      redirectApplicationJourneyUrl ||
                      leadResponse?.URL ||
                      "#"
                    }
                    external
                    openInNewTab={false}
                    onClick={(e) => {
                      e.preventDefault();
                      redirectHandler(
                        redirectApplicationJourneyUrl || leadResponse?.URL,
                      );
                    }}
                    className={styles.proceedToApply}
                  >
                    Proceed to Apply
                  </UnivoLink>
                )}
              </div>
              )
            ) : (
              <>
                {/* Keep RFI title until OTP mounts — leadResponse can arrive
                    earlier than isOTPSent and used to hide the heading first
                    (flicker/blank). Hide heading in the same paint as OTP. */}
                {!isOTPSent && (
                  <div
                    className={`${
                      isJobRole
                        ? styles.jobRoleHeading
                        : isFaq
                          ? styles.headingFaq
                          : styles.heading
                    } ${isCityPage ? "sm:text-center" : ""}`}
                  >
                    {isJobRole ? "Enquire Now" : isFaq ? FaqHeading : RFIHeading}
                  </div>
                )}
                <OTPContextWrapper isNewProgramTemp isLambdaAPI={isLambdaAPI}>
                  <ProgramDetailsOpenRfi
                    isFaq={isFaq}
                    ProgramId={ProgramId}
                    associatedPrograms={associatedPrograms}
                    isMobile={isMobile}
                    setApplicationRedirectLoaderDisabled={
                      setApplicationRedirectLoaderDisabled
                    }
                    BannerImageTemplete={BannerImageTemplete}
                    isLandingPage={isLandingPage}
                    isLambdaAPI={isLambdaAPI}
                    isAffiliatePage={isAffiliatePage}
                    seatFilledDisplay={seatFilledDisplay}
                    isStatsDisplay={isStatsDisplay}
                    seatFilledCount={seatFilledCount}
                    isJobRole={isJobRole || isJobPage}
                    ctaButtonLabel={ctaButtonLabel}
                    isOneYearMba={isOneYearMba}
                    slug={slug}
                  />
                </OTPContextWrapper>
              </>
            );
          }}
        </OTPContext.Consumer>
      </OTPContextProvider>
    </div>
  );
}
